module.exports = __webpack_public_path__ + "static/media/bk_swiper_x.661ae0be.jpg";